export default "__VITE_ASSET__808f7c5a__"